import { HTTP_STATUS_CODES } from '~/constants/http-status-codes';
import type { ResponseCallbacks } from './api';

type ApiResponse<T> = T;
export const handleResponse = async (responseObj: any,  
    responseCallbacks?: ResponseCallbacks<any>): Promise<ApiResponse<any>> => {
  const dialog = useMessageDialog()
  const response = responseObj.response_data;

  if(responseCallbacks?.successCallback) {
    const isAdmin = window.location.pathname.startsWith('/admin');
    if (isAdmin) {
      dialog.show($t('normal_finish_success'), ()=>{
        responseCallbacks.successCallback?.(response);  
      } );
    } else {
      dialog.show($t('normal_finish_success'));
      responseCallbacks.successCallback?.(response);  
    }
  }
  return responseObj;

};
